module.exports = __webpack_public_path__ + "static/media/b2p.3522429c.png";